import { render, staticRenderFns } from "./DefectExternalView.vue?vue&type=template&id=5238bcfc&"
import script from "./DefectExternalView.vue?vue&type=script&lang=js&"
export * from "./DefectExternalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports